import { render, staticRenderFns } from "./personList.vue?vue&type=template&id=4c205c41&scoped=true&"
import script from "./personList.vue?vue&type=script&lang=js&"
export * from "./personList.vue?vue&type=script&lang=js&"
import style0 from "./personList.vue?vue&type=style&index=0&id=4c205c41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c205c41",
  null
  
)

export default component.exports